import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@herit-fe/heritage-ui';
import { UI_TEXT } from '@/shared/languages';

export type RevenuePopupType = 'none' | 'selfNotSet' | 'saleNotSet';

/**
 * 미등록/미설정 안내 팝업 — 자가소비 미입력(요금편익 안내) / 발전사업·전체 미입력(추정수익 안내, 발전소 유형 안내
 * 리스트). 확인=발전소 추가정보 입력. 구앱 `RevenuePopup` 이식(색·컴포넌트는 우리 것, heritage `Dialog`).
 * 수익 리포트·대시보드(전체/단일 미완료 수익 클릭) 공유 → shared/ui.
 *
 * `Dialog`(AlertDialog 아님) — 마스킹 값(`???`) 위에 뜨므로 X 버튼·배경(dimmed) 클릭·ESC 로 자유롭게 닫혀야 한다
 * (안내는 강제 액션이 아님). 변형별로 **별도 Dialog 2개**(동시 최대 1개 open) — 각 다이얼로그 내용이 고정이라 닫힘
 * 애니메이션 중 제목이 순간 뒤바뀌던 플래시가 원천 제거된다.
 */
export function RevenuePopup({
  type,
  onClose,
  onConfirm,
}: {
  type: RevenuePopupType;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <>
      <GuideDialog
        variant="sale"
        open={type === 'saleNotSet'}
        onClose={onClose}
        onConfirm={onConfirm}
      />
      <GuideDialog
        variant="self"
        open={type === 'selfNotSet'}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    </>
  );
}

function GuideDialog({
  variant,
  open,
  onClose,
  onConfirm,
}: {
  variant: 'sale' | 'self';
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const isSale = variant === 'sale';
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isSale ? UI_TEXT.REVENUE_POPUP_SALE_TITLE : UI_TEXT.REVENUE_POPUP_SELF_TITLE}
          </DialogTitle>
          <DialogDescription className="whitespace-pre-line text-left leading-relaxed">
            {isSale ? UI_TEXT.REVENUE_POPUP_SALE_MESSAGE : UI_TEXT.REVENUE_POPUP_SELF_MESSAGE}
          </DialogDescription>
        </DialogHeader>
        {isSale ? (
          <ul className="flex flex-col gap-1 text-sm text-muted-foreground">
            <li>
              · <b className="text-foreground">{UI_TEXT.REVENUE_POPUP_SALE_ITEM_SALE}</b>
              {UI_TEXT.REVENUE_POPUP_SALE_ITEM_SALE_DESC}
            </li>
            <li>
              · <b className="text-foreground">{UI_TEXT.REVENUE_POPUP_SALE_ITEM_SELF}</b>
              {UI_TEXT.REVENUE_POPUP_SALE_ITEM_SELF_DESC}
            </li>
          </ul>
        ) : null}
        <DialogFooter>
          <Button onClick={onConfirm}>{UI_TEXT.REVENUE_POPUP_CONFIRM}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
